import * as React from 'react';
import SecondaryButton from '../../../../common/secondary-button';
import * as styles from '../navigation.module.scss';
import { FormControl, InputLabel, Select, MenuItem, withStyles, createStyles, InputBase } from '@material-ui/core';
import Navigation from '../../../../../models/navigation';
import { NewNavigation } from '../../../../../hooks/useNavigation';
import Dashboard from '../../../../../models/dashboard';
import clsx from 'clsx';
import { fontFamilies } from '../../../../../theme/text';

const AddDashboardInput = withStyles(() =>
  createStyles({
    root: { marginRight: '20px' },
    input: {
      borderRadius: 4,
      position: 'relative',
      border: '1px solid #d1cece',
      padding: '10.5px 14px',
      fontFamily: fontFamilies.body,
      fontSize: '16px',
      lineHeight: '17px',
      width: '250px',
      color: '#4f4f4f',
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        backgroundColor: 'white'
      }
    }
  })
)(InputBase);

interface Props {
  clientId: number;
  navigations: Navigation[];
  updating: boolean;
  addNavigationHandler: (navigation: NewNavigation) => void;
  setErrorMessage: (message: string) => void;
  setSuccessMessage: (message: string) => void;
  loadingDashboards: boolean;
  clientDashboards: Dashboard[];
}

const AddDashboardNav = ({
  navigations,
  updating,
  addNavigationHandler,
  loadingDashboards,
  clientDashboards
}: Props) => {
  const [selectedDashboard, setSelectedDashboard] = React.useState<number>(0);
  const addDashboardSelectHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedDashboard(Number(event.target.value));
  };

  const addDashboardHandler = (event?: React.FormEvent<HTMLFormElement>) => {
    event && event.preventDefault();
    const [parentNav] = navigations.slice(-1);
    const dashboard = clientDashboards.find(dashboard => dashboard.reportId === selectedDashboard);
    const seqOrder = parentNav.children.length;

    const newDashboard = {
      name: dashboard.name,
      seqOrder,
      link: dashboard.reportId.toString(),
      parentId: parentNav.navigationId
    };
    addNavigationHandler(newDashboard);
  };
  return (
    <form onSubmit={event => addDashboardHandler(event)}>
      <FormControl className={styles.formControl}>
        <InputLabel id={'add-dashboard-select'} style={{ display: 'none' }}>
          Add Dashboard
        </InputLabel>
        <Select
          className={clsx(styles.select, clientDashboards.length === 0 && styles.selectDisabled)}
          labelId={'add-dashboard-select'}
          value={selectedDashboard ? selectedDashboard : ''}
          onChange={addDashboardSelectHandler}
          input={<AddDashboardInput />}
          disabled={loadingDashboards || clientDashboards.length === 0}
        >
          {clientDashboards &&
            clientDashboards.map(dashboard => (
              <MenuItem value={dashboard.reportId} key={dashboard.reportId}>
                {dashboard.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <SecondaryButton
        text="Add"
        title="Add"
        handleClick={addDashboardHandler}
        deactive={!selectedDashboard || updating}
      />
    </form>
  );
};

export default AddDashboardNav;
